import React from "react";
import { useQuery } from "@apollo/client";
import queries from "Shared/queries";
import { goToReportPage, queryParamsToProps } from "./services/queryParams";
import { useRouter } from "Hooks/useRouter";
import { DateRangeInput, GetProviderDisbursementsQuery, GetProviderDisbursementsQueryVariables } from "generated/graphql";

export const useProviderDisbursements = () => {
  const { history, location } = useRouter();
  const { page, beginDate, endDate, requesterId } = queryParamsToProps(location.search);
  const createdAtBetween = beginDate && endDate
    ? {
      beginDate,
      endDate
    }
    : undefined;
  const rowsPerPage = parseInt(
    process.env.REACT_APP_DISBURSEMENTS_ROWS_PER_PAGE!,
    10
  );

  const { data, loading } = useQuery<
    GetProviderDisbursementsQuery,
    GetProviderDisbursementsQueryVariables
  >(
    queries.GET_PROVIDER_DISBURSEMENTS,
    {
      variables: {
        page,
        perPage: rowsPerPage,
        createdAtBetween,
        requesterId,
      }
    }
  );

  const onChangePage = (
    evt: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => goToReportPage(history, { page: newPage, beginDate, endDate, requesterId });

  const onChangeDateRange = (
    range: DateRangeInput
  ) => goToReportPage(history, {
    page: 1,
    beginDate: range.beginDate,
    endDate: range.endDate,
    requesterId,
  });

  const onChangeRequestor = (newRequesterId: string) => {
    return goToReportPage(history, {
      page: 1,
      beginDate,
      endDate,
      requesterId: newRequesterId,
    });
  };

  return {
    data,
    beginDate,
    endDate,
    loading,
    page,
    rowsPerPage,
    requesterId,
    onChangePage,
    onChangeDateRange,
    onChangeRequestor,
  };
};
